export enum ContactFormInputNames {
	Name = "name",
	EmailAddress = "emailAddress",
	Message = "message",
	SignUpNewsletter = "signupNewsletter",
}
